import { CommonModule } from '@angular/common';
import { Component, computed, input, InputSignal, Signal } from '@angular/core';
import { AbstractControl, ReactiveFormsModule, UntypedFormArray, UntypedFormGroup } from '@angular/forms';

import { v4 as uuid } from 'uuid';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { UiTranslateModule } from '@fcom/ui-translate/index';

import { IconsModule } from '../../icons';
import { CheckBoxTheme } from '../enums';

@Component({
  selector: 'fcom-checkbox-input',
  imports: [CommonModule, ReactiveFormsModule, UiTranslateModule, IconsModule],
  templateUrl: './checkbox-input.component.html',
  styleUrl: './checkbox-input.component.scss',
})
export class CheckboxInputComponent {
  readonly checkboxId: string = uuid();
  readonly CheckBoxTheme = CheckBoxTheme;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  center: InputSignal<boolean> = input<boolean>(false);
  checkboxValue: InputSignal<string | boolean> = input<string | boolean>(false);
  controlName: InputSignal<string> = input.required<string>();
  iconSize: InputSignal<string> = input<string>('icon-medium');
  parentForm: InputSignal<UntypedFormGroup | UntypedFormArray> = input<UntypedFormGroup | UntypedFormArray>();
  showCheckboxIcon: InputSignal<boolean> = input<boolean>(true);
  theme: InputSignal<CheckBoxTheme> = input<CheckBoxTheme>(CheckBoxTheme.SQUARE);
  translationPrefix: InputSignal<string> = input<string>();
  useLabelText: InputSignal<boolean> = input<boolean>(false);

  ctrlField: Signal<AbstractControl> = computed(() => {
    return this.parentForm()?.get(this.controlName()) ?? null;
  });

  required: Signal<AbstractControl | boolean> = computed((): boolean => this.ctrlField()?.errors?.required ?? false);
}
